import './pages/subscription_index';
import './pages/subscription_cancelation';

global.initStripeButton = (action) => import('./components/stripe').then(module => module.initStripeButton(action));
global.preloadStripe = () => import('./components/stripe').then(module => module.preloadStripe());
